import {
  DEFAULT_USER_FIRST_NAME,
  DEFAULT_USER_LAST_NAME,
} from '@/shared/config';

const clean = (value?: string) => value?.trim() ?? '';

export const getInitial = (firstName?: string, lastName?: string) => {
  const source = clean(firstName) || clean(lastName) || DEFAULT_USER_FIRST_NAME;
  return source.charAt(0).toUpperCase();
};

export const getShortName = (firstName?: string, lastName?: string) => {
  const first = clean(firstName);
  const last = clean(lastName);

  if (!first && !last) {
    return `${DEFAULT_USER_FIRST_NAME.charAt(0)}. ${DEFAULT_USER_LAST_NAME}`;
  }

  if (!first) {
    return last;
  }

  if (!last) {
    return first;
  }

  return `${first.charAt(0).toUpperCase()}. ${last}`;
};

export const getFullName = (firstName?: string, lastName?: string) => {
  const parts = [clean(firstName), clean(lastName)].filter(Boolean);

  if (parts.length === 0) {
    return `${DEFAULT_USER_FIRST_NAME} ${DEFAULT_USER_LAST_NAME}`;
  }

  return parts.join(' ');
};
